import {Component, Input, OnInit} from '@angular/core';
import {QuickCard} from '../../../classes/QuickCard';
import {QuickCardService} from '../../../services/quick-card.service';
import {QuickCardValue} from '../../../enums/QuickCardValue';
import {OrderStatus} from '../../../enums/OrderStatus';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-quick-card-list',
  styleUrls: ['./quick-card-list.component.scss'],
  templateUrl: './quick-card-list.component.html',
})
export class QuickCardListComponent implements OnInit {

  @Input() isAdmin = true;

  public quickCards: QuickCard[];
  public errorMessage: string;
  public QuickCardValue = QuickCardValue;
  public OrderStatus = OrderStatus;
  public filterForm: FormGroup;

  constructor(private quickCardService: QuickCardService,
              private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {

    this.filterForm = this.formBuilder.group({
      quickCardStatus: 'ACTIVE'
    });

    this.refreshList();

    this.filterForm.controls.quickCardStatus.valueChanges.subscribe(() => this.refreshList());
  }

  refreshList(): void {

    const status = this.filterForm.controls.quickCardStatus.value;

    if (this.isAdmin) {
      this.quickCardService.getAll(status).subscribe({
        next: (quickCards) => {
          this.quickCards = quickCards;
        },
        error: (error) => this.errorMessage = error.error.error
      });
    } else {
      this.quickCardService.getUserQuickCards(status).subscribe({
        next: (quickCards) => {
          this.quickCards = quickCards;
        },
        error: (error) => this.errorMessage = error.error.error
      });
    }
  }
}
